function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_35",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#f0bc5e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 2h60v8h-60z",
    fill: "#f0bc5e",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 35h14v6h-14z",
    fill: "#f0bc5e",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 32h-6v-19h6z",
    fill: "#f0bc5e",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 32h-6v-11h6z",
    fill: "#f0bc5e",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 32h-6v-17h6z",
    fill: "#f0bc5e",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1 1v44h12v14.5c0 1.93 1.57 3.5 3.5 3.5.98 0 1.864-.407 2.5-1.058.636.651 1.52 1.058 2.5 1.058 1.93 0 3.5-1.57 3.5-3.5v-14.5h38v-44zm22 33v25.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-18.5h-2v18.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-25.5h-2v9c-1.103 0-2-.897-2-2v-6c0-4.411 3.589-8 8-8s8 3.589 8 8v6c0 1.103-.897 2-2 2v-9zm-9-14c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5zm47 23h-32.556c.344-.591.556-1.268.556-2v-5.434l4.277-2.566h25.723v-2h-26.277l-3.875 2.325c-.576-3.392-2.855-6.21-5.933-7.525 1.86-1.26 3.085-3.39 3.085-5.8 0-3.859-3.14-7-7-7s-7 3.141-7 7c0 2.41 1.225 4.54 3.085 5.8-3.574 1.526-6.085 5.075-6.085 9.2v6c0 .732.212 1.409.556 2h-6.556v-40h58z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 5h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 5h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 5h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 48.586-2 2v-2.586h-2v10h2v-2.586l2 2v.586h2v-1.414l-3.586-3.586 3.586-3.586v-1.414h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.5 48h-3.5v10h2v-3h1.5c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5zm0 5h-1.5v-3h1.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 50h2v6h-2v2h6v-2h-2v-6h2v-2h-6z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 35h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 35h10v2h-10z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 39h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 39h10v2h-10z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 39h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 35h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 31h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpi);
export default __webpack_public_path__ + "static/media/kpi.054ec80b66b0a4dd38d56067208d42f6.svg";
export { ForwardRef as ReactComponent };